import styled from "styled-components";

export const StyledErrorValidation = styled.div`
  font-size: 13px;
  line-height: 120%;
  letter-spacing: -0.24px;
  color: #F6657F;
  margin-bottom: 14px;
`
